import {
  type ComposerTranslation,
  createI18n,
  type DefineLocaleMessage,
  type I18n,
} from "vue-i18n";

import pl from "@/translations/pl.json";
import en from "@/translations/en.json";
import ua from "@/translations/ua.json";
import type { Locale } from "@/composables/useLocale";
import { getLocaleFromCookie } from "@/lib/cookie.ts";
import type { RemoveIndexSignature } from "@intlify/core-base";

// pl is base language and contains all keys that are required to be translated
export type MessageSchema = typeof pl;

function solveLocale(): string {
  return getLocaleFromCookie() || "pl";
}

// defining i18n instance typechecked to make sure all strings are translated
const i18n: I18n = createI18n<[MessageSchema], Locale>({
  locale: solveLocale(),
  fallbackLocale: "en",

  legacy: false,

  messages: {
    pl: pl,
    ua: ua,
    en: en as unknown as MessageSchema, // en is a fallback and may be incomplete, hence this cast
  },

  numberFormats: {
    pl: {
      currency: {
        style: "currency",
        currency: "PLN",
        currencyDisplay: "code",
      },
    },
    en: {
      currency: {
        style: "currency",
        currency: "PLN",
        currencyDisplay: "code",
      },
    },
    ua: {
      currency: {
        style: "currency",
        currency: "PLN",
        currencyDisplay: "code",
      },
    },
  },
}) as I18n;

export default {
  ...i18n,
  t: i18n.global.t,
  n: i18n.global.n,
};

export const t = i18n.global.t as ComposerTranslation<
  MessageSchema,
  Locale,
  RemoveIndexSignature<{
    [K in keyof DefineLocaleMessage]: DefineLocaleMessage[K];
  }>
>;
